// extracted by mini-css-extract-plugin
export default {"container":"CreatePost_container__9IMIp","title":"CreatePost_title__t5SXp","paragraph":"CreatePost_paragraph__dbq9t"};